import React from "react";
const SvgAvatar = props => (
  <svg viewBox="0 0 23 28" {...props}>
    <path
      fill="none"
      stroke="#39434E"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M.7 26.4a10.5 10.5 0 1121 0M11.2 10.9a5 5 0 100-10.2 5 5 0 100 10.2z"
    />
  </svg>
);
export default SvgAvatar;
